/**
 * Mixin for contact message handling functionality
 * Provides methods for managing messages (fetch, submit, draft, toggle)
 */
import ApiService from '@/service/apiService';
import Api from '@/config/api';

export default {
  methods: {
    async findMessageByJobseeker() {
      try {
        this.loading = true;
        let messageByJobseeker = await ApiService.get(
          Api.endpoints.MESSAGE_BY_JOBSEEKER(this.applicantId)
        );
        if (messageByJobseeker.data.length > 0)
          this.openMessageComposeForm = false;
        this.messageByJobseeker = messageByJobseeker.data;
        // add details visible property by using vue's set to make it reactive
        this.messageByJobseeker.forEach((message) => {
          this.$set(message, 'detailsVisible', false);
        });
        this.loading = false;
      } catch (err) {
        this.parseErrorResponse(err.response);
        this.loading = false;
      }
    },
    findDraftMessage() {
      const draftMessage = this.messageByJobseeker.find(
        (msg) => msg.is_draft === true
      );
      if (draftMessage) {
        this.openMessageComposeForm = true;
        this.is_draft = true;
        this.draftMessage = draftMessage;
      }
    },
    async onSubmit({ data, reset, hide, draftId }) {
      try {
        this.isSubmitting = true;
        let method;
        let endpoint;
        if (draftId) {
          method = 'put';
          endpoint = Api.endpoints.SEND_DRAFT_MESSAGE_TO_JOBSEEKER(draftId);
        } else {
          method = 'post';
          endpoint = Api.endpoints.SEND_MESSAGE_TO_JOBSEEKER(this.applicantId);
        }
        let response = await ApiService[method](endpoint, data);
        if (response) {
          let newMessage = response.data;
          newMessage.detailsVisible = false;
          let jobseekerMessages = this.messageByJobseeker;
          jobseekerMessages.push(newMessage);
          this.messageByJobseeker = jobseekerMessages;
          this.is_draft = false;
          this.draftMessage = {};
          this.openMessageComposeForm = false;
          if (typeof reset === 'function') reset();
          if (typeof hide === 'function') hide();

          // Set both new_status and status from API response (e.g. スカウト済)
          const statusValue =
            newMessage.status != null
              ? newMessage.status
              : newMessage.new_status != null
                ? newMessage.new_status
                : 'スカウト済';
          const apiStatus = {
            new_status: statusValue,
            status: statusValue,
          };
          this.$store.commit('setApplicantStatus', apiStatus);
          if (this.applicant && this.applicant.id) {
            this.$store.commit('mutateApplicantsAfterStatus', {
              id: this.applicant.id,
              new_status: apiStatus.new_status,
              status: apiStatus.status,
            });
            this.$store.commit('mutateApplicantsAfterContact', {
              applicantId: this.applicant.id,
              contact: newMessage,
            });
          }
        }
        if (this.removeApplicantFromTempList) {
          this.removeApplicantFromTempList(this.applicant);
        }
        this.isSubmitting = false;
      } catch (err) {
        this.isSubmitting = false;
        this.parseErrorResponse(err);
      }
    },
    async onDraft({ data, draftId }) {
      try {
        this.isSubmitting = true;
        let method;
        let endpoint;
        if (draftId) {
          method = 'put';
          endpoint = Api.endpoints.EDIT_DRAFT_MESSAGE(draftId);
        } else {
          method = 'post';
          endpoint = Api.endpoints.DRAFT_MESSAGE(this.applicantId);
        }
        let response = await ApiService[method](endpoint, data);
        if (response) {
          this.addFlashMessages([
            { message: '下書きを保存しました', type: 'success' },
          ]);
          let newMessage = response.data;
          let jobseekerMessages = this.messageByJobseeker;
          jobseekerMessages.push(newMessage);
          this.messageByJobseeker = jobseekerMessages;
          this.draftMessage = newMessage;
          window.scrollTo(0, 0);
        }
        this.isSubmitting = false;
      } catch (err) {
        this.isSubmitting = false;
        this.parseErrorResponse(err);
      }
    },
    toggleMessageDetails(item) {
      item.detailsVisible = !item.detailsVisible;
      this.selectedMessageId = item.detailsVisible ? item._id : null;
    },
  },
};

